
import { PolicyFormFieldsProps } from "./types";
import { BasicPolicyFields } from "./fields/BasicPolicyFields";
import { LeadSourceField } from "./fields/LeadSourceField";
import { PolicyDetailsFields } from "./fields/PolicyDetailsFields";
import { StatusField } from "./fields/StatusField";
import { DateRangeFields } from "./components/DateRangeFields";
import { Form } from "@/components/ui/form";
import { useForm } from "react-hook-form";
import { LEAD_SOURCES } from "../constants/leadSources";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export const PolicyFormFields = ({
  producer,
  policyType,
  insuranceCarrier,
  policyLine,
  policyNumber,
  startDate = new Date(),
  endDate,
  premiumAmount,
  status,
  leadSource,
  policyAcquisitionType,
  onProducerChange,
  onPolicyTypeChange,
  onInsuranceCarrierChange,
  onPolicyLineChange,
  onPolicyNumberChange,
  onStartDateChange,
  onEndDateChange,
  onPremiumAmountChange,
  onStatusChange,
  onLeadSourceChange,
  onPolicyAcquisitionTypeChange,
  onSalesDateChange,
}: PolicyFormFieldsProps) => {
  const form = useForm({
    defaultValues: {
      leadSource: ""
    }
  });

  // Get the local date in YYYY-MM-DD format
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const today = new Date(now.getTime() - (offset * 60 * 1000))
    .toISOString()
    .split('T')[0];

  return (
    <Form {...form}>
      <div className="space-y-4">
        <div className="space-y-2">
          <Label>Sales Date</Label>
          <Input
            type="date"
            defaultValue={today}
            onChange={(e) => onSalesDateChange?.(new Date(e.target.value))}
            className="h-14"
          />
        </div>

        <BasicPolicyFields
          producer={producer}
          policyType={policyType}
          insuranceCarrier={insuranceCarrier}
          policyLine={policyLine}
          policyAcquisitionType={policyAcquisitionType}
          onProducerChange={onProducerChange}
          onPolicyTypeChange={onPolicyTypeChange}
          onInsuranceCarrierChange={onInsuranceCarrierChange}
          onPolicyLineChange={onPolicyLineChange}
          onPolicyAcquisitionTypeChange={onPolicyAcquisitionTypeChange}
        />
        
        <LeadSourceField
          form={form}
          leadSources={LEAD_SOURCES}
          onLeadSourceChange={onLeadSourceChange}
        />
        
        <PolicyDetailsFields
          policyNumber={policyNumber}
          premiumAmount={premiumAmount}
          onPolicyNumberChange={onPolicyNumberChange}
          onPremiumAmountChange={onPremiumAmountChange}
        />
        
        <StatusField
          status={status}
          onStatusChange={onStatusChange}
        />
        
        <DateRangeFields
          startDate={startDate}
          endDate={endDate}
          onStartDateChange={onStartDateChange}
          onEndDateChange={onEndDateChange}
        />
      </div>
    </Form>
  );
};
